export var IntegrationGatewayFeedState;
(function (IntegrationGatewayFeedState) {
    IntegrationGatewayFeedState["Active"] = "Active";
    IntegrationGatewayFeedState["Inactive"] = "Inactive";
    IntegrationGatewayFeedState["SoftDeleted"] = "SoftDeleted";
})(IntegrationGatewayFeedState || (IntegrationGatewayFeedState = {}));
//# sourceMappingURL=feed.js.map